// This is just used to gracefully deactivate components at build time.

export default function emptyComponent() {
  if (this?.constructor === emptyComponent) {
    this.isDisabled = true;
  }
  return null;
}
emptyComponent.isDisabled = true;
